import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { Button } from '@blueprint/ui';
import { AgentImageWrapper } from '../FeaturedProperties.styles';

const CTAWrapper = styled(AgentImageWrapper)(
    () => css`
        border-top: 0;

        ${Button} {
            margin: 0;
            line-height: initial;
        }
    `
);

const PromoCardImage = styled('div')`
    display: block;
    width: 100%;
    height: 11.125rem; /* 178px */
    flex-shrink: 0;
`;

const PromoCardDetails = styled('div')(
    () => css`
        display: flex;
        flex-direction: column;
        align-self: stretch;
        flex: 1;
    `
);

export { CTAWrapper, PromoCardImage, PromoCardDetails };
